import { useState } from 'react';
import moment from 'moment';

import { Modal, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import notifier from 'utils/notifier';
import { ErrorResponse } from 'utils/types';
import DropzoneLocal from 'components/Common/Dropzone';

const { Title } = Typography;

interface AttachmentModalProps {
  uploadAttachment(uploadObject: Object): any;
  isUploading: boolean;
  isAttachmentModalVisible: boolean;
  setVisible(visible: boolean): void;
  claimNo: string | number;
};

interface AttachmentResponse {
  RmiUid: number;
  RmiCompanyId: string;
  RmiClaimReferenceNo: string;
  RmiSequence: number;
  RmiOrigFileName: string;
  RmiStoredFileName: string;
  RmiUploadBy: string;
  RmiUploadDate: string;
};

const AttachmentModal = (props: AttachmentModalProps) => {

  const [fileList, setFileList] = useState<Blob[]>([]);

  const onUpload = () => {
    const formdata = new FormData();
    formdata.append('RmiUserId', sessionStorage.getItem('user_id')!);
    formdata.append('FileExtensions', '.TIF, .TIFF, .JPG, .JPEG, .PDF, .DOC, .DOCX');
    formdata.append('RmiCompanyId', sessionStorage.getItem('ipa')!);
    formdata.append('date', moment().format());
    formdata.append('RmiClaimReferenceNo', props.claimNo.toString());
    formdata.append("updateAttachment", "1");
    fileList.forEach(file => formdata.append('uploadfile[]', file));

    props.uploadAttachment(formdata)
      .then((response: AttachmentResponse[]) => {
        notifier.success(`Files uploaded successfully.`);
        props.setVisible(false);
        return response;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const onReset = () => {
    setFileList([]);
    props.setVisible(false);
  };

  return (
    <>
      <Modal 
        className="modal-width"
        width={'750px'}
        visible={props.isAttachmentModalVisible} 
        onCancel={onReset}
        onOk={onUpload}
        okText={<>Upload <UploadOutlined /></>}
        okButtonProps={{ 
          disabled: fileList.length === 0, 
          loading: props.isUploading 
        }}
      >
        <div className="container">
          <Title level={3}>
            Claim Attachment : {props.claimNo}
          </Title>
        </div>
        <DropzoneLocal 
          fileList={fileList}
          setFileList={setFileList}
        />
      </Modal>
    </>
   );
};

export default AttachmentModal;